"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _uniqueIdHelper = require("../../helpers/unique-id-helper");

var _cookieHelper = require("@eig-builder/core-utils/helpers/cookie-helper");

var _scriptHelper = require("@eig-builder/core-utils/helpers/script-helper");

var _runtimeConfigHelper = require("./../../helpers/runtime-config-helper");

var _moment = _interopRequireDefault(require("moment"));

/**
 * FaaS Logger, includes javascript
 *
 * @class FaasLogger
 */
var FaasLogger = /*#__PURE__*/function () {
  function FaasLogger() {
    (0, _classCallCheck2["default"])(this, FaasLogger);
  }

  (0, _createClass2["default"])(FaasLogger, [{
    key: "init",
    value: function init() {
      var internalEnv = (0, _cookieHelper.getCookie)('endurance-tester-cookie');
      var forceFaas = (0, _cookieHelper.getCookie)('forceFaas');
      var userId = '';
      /*
       * enabled FaaS if in an internal environment, forceFaas cookie is enabled,
       * or if user is in an external environment (internalEnv is not true)
       */

      if (internalEnv === 'true' && forceFaas === 'true' || internalEnv !== 'true') {
        var faasID = this.getFaasSessionID();
        this.includeJs(faasID, userId);
      }
    }
  }, {
    key: "includeJs",
    value: function includeJs(faasID, userIdCookie) {
      // eslint-disable-next-line no-sequences, no-undef, no-sequences, one-var
      var userId = userIdCookie; // Set to the user's ID, username, or email address, or '' if not yet known.

      var sessionId = faasID; // Set to a unique session ID for the visitor's current browsing session.

      var PROD_BEACON_KEY = 'a11f14f85d';
      var NON_PROD_BEACON_KEY = '733df8b861';
      var beaconKey = (0, _runtimeConfigHelper.getRuntimeConfig)()._env === 'prod' ? PROD_BEACON_KEY : NON_PROD_BEACON_KEY; // use different beacon keys for prod vs other envs

      var _sift = window._sift = window._sift || [];

      _sift.push(['_setAccount', beaconKey]);

      _sift.push(['_setUserId', userId]);

      _sift.push(['_setSessionId', sessionId]);

      _sift.push(['_trackPageview']);

      (0, _scriptHelper.IncludeJavaScript)('https://cdn.sift.com/s.js', 'faasScript');
    }
  }, {
    key: "getFaasSessionID",
    value: function getFaasSessionID() {
      var faasSID = (0, _cookieHelper.getCookie)('faasSID');

      if (!faasSID) {
        faasSID = (0, _uniqueIdHelper.generateGuid)() + (0, _moment["default"])().format('MMDDYYYYhhmmss');
        (0, _cookieHelper.setCookie)('faasSID', faasSID);
      }

      return faasSID;
    }
  }]);
  return FaasLogger;
}();

var _default = new FaasLogger();

exports["default"] = _default;